/* eslint-disable @typescript-eslint/no-explicit-any */
// i18next v23+ requires TypeScript 5+. This project uses TypeScript 4.9.5 (CRA).
// Type assertions below are intentional to bridge the incompatibility.

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonEn from './en/common.json';
import appointmentsEn from './en/appointments.json';
import errorsEn from './en/errors.json';
import authEn from './en/auth.json';
import billingEn from './en/billing.json';
import onboardingEn from './en/onboarding.json';
import sponsoredPlacementsEn from './en/sponsoredPlacements.json';
// AB#1796 (CR-2026-05-29) — Calendar i18n namespace (Quick-Book Confirm copy).
import calendarEn from './en/calendar.json';
// AB#1006 — Super Admin Platform Promotions namespace.
import platformPromotionsEn from './en/platformPromotions.json';

import commonAr from './ar/common.json';
import appointmentsAr from './ar/appointments.json';
import errorsAr from './ar/errors.json';
import authAr from './ar/auth.json';
import billingAr from './ar/billing.json';
import onboardingAr from './ar/onboarding.json';
import sponsoredPlacementsAr from './ar/sponsoredPlacements.json';
import calendarAr from './ar/calendar.json';
import platformPromotionsAr from './ar/platformPromotions.json';

const i18nInstance = i18n as any;

// Sync RTL/LTR attribute with language changes
i18nInstance.on('languageChanged', (lang: string) => {
  document.dir = lang === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = lang;
});

i18nInstance
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: commonEn,
        appointments: appointmentsEn,
        errors: errorsEn,
        auth: authEn,
        billing: billingEn,
        onboarding: onboardingEn,
        sponsoredPlacements: sponsoredPlacementsEn,
        calendar: calendarEn,
        platformPromotions: platformPromotionsEn,
      },
      ar: {
        common: commonAr,
        appointments: appointmentsAr,
        errors: errorsAr,
        auth: authAr,
        billing: billingAr,
        onboarding: onboardingAr,
        sponsoredPlacements: sponsoredPlacementsAr,
        calendar: calendarAr,
        platformPromotions: platformPromotionsAr,
      },
    },
    // Prefer the key stored by LanguageContext (devanza_language)
    lng: (localStorage.getItem('devanza_language') as 'en' | 'ar') ?? 'ar',
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'devanza_language',
    },
  });

export default i18n;

/** Type-safe changeLanguage wrapper for TypeScript 4.9.5 compatibility */
export const changeLanguage = (lang: string): Promise<unknown> =>
  i18nInstance.changeLanguage(lang) as Promise<unknown>;
